import { render, staticRenderFns } from "./template.vue?vue&type=template&id=080ceb84&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=080ceb84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ceb84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080ceb84')) {
      api.createRecord('080ceb84', component.options)
    } else {
      api.reload('080ceb84', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=080ceb84&scoped=true&", function () {
      api.rerender('080ceb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/template.vue"
export default component.exports